import { FIELD_TYPES } from '../../constants';
const getServiceFieldOptions = (field)=>{
    if (field.identifier === FIELD_TYPES.SERVICES_DROPDOWN) {
        return field.inputOptions?.stringOptions?.servicesDropdownOptions?.options;
    }
    if (field.identifier === FIELD_TYPES.SERVICES_MULTI_CHOICE) {
        return field.inputOptions?.arrayOptions?.servicesCheckboxGroupOptions?.options;
    }
    return undefined;
};
export const getServiceOptionIds = (form, useFieldsV2)=>{
    if (!useFieldsV2) {
        return form.fields?.filter((field)=>field.view?.fieldType === FIELD_TYPES.SERVICES_DROPDOWN || field.view?.fieldType === FIELD_TYPES.SERVICES_MULTI_CHOICE).map((field)=>field.view?.options?.map((option)=>option.id)).flat();
    }
    return (form.formFields ?? []).flatMap((field)=>getServiceFieldOptions(field) ?? []).map((option)=>option.id).filter((id)=>Boolean(id));
};
export const serviceSorter = (a, b)=>{
    return (a.category?.sortOrder ?? 0) - (b.category?.sortOrder ?? 0) || (a.sortOrder ?? 0) - (b.sortOrder ?? 0);
};

//# sourceMappingURL=service-utils.js.map